import { z } from 'zod';

export const DocumentRevisionSchema = z.object({
    id: z.string().optional(),
    document: z.string().min(1),
    version: z.number().optional(),
    versionLabel: z.string().optional(),
    fileUrl: z.string().optional(),
    fileName: z.string().optional(),
    fileType: z.enum(['docx', 'xlsx', 'pdf', 'other']).optional(),
    mimeType: z.string().optional(),
    fileSize: z.number().optional(),
    status: z.enum(['draft', 'pending-approval', 'approved', 'rejected', 'archived']).default('draft'),
    isActive: z.boolean().default(false),
    isDynamic: z.boolean().default(false),
    reportTemplate: z.string().optional(),
    notes: z.string().optional(),
    changeDescription: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateDocumentRevisionSchema = DocumentRevisionSchema.omit({
    id: true,
    version: true,
    versionLabel: true,
    fileUrl: true,
    createdAt: true,
    updatedAt: true,
});

export const UpdateDocumentRevisionSchema = DocumentRevisionSchema.partial();
